import { Fieldset, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { FavoriteButton } from 'src/Components/Shared/FavoriteButton';
import { ContactKind, CreatePaymentMethodDtoTypeEnum } from 'src/Services/API/generated';

import { paymentMethodsConfig } from '../paymentMethodsConfig';

import styles from './BankSectionForm.module.scss';
import { Props } from './BankSectionForm.types';

const BankSectionForm = ({ form }: Props) => {
  const { t } = useTranslation();
  // A company is paid by transfer only: Lydia, PayPal and Wero are hidden (saved values stay).
  const isCompany = form.values.kind === ContactKind.Company;

  return (
    <Fieldset legend={t('contacts.bankingInformation', 'Informations bancaires')}>
      <div className={styles.bankingInformations}>
        <TextInput
          variant="textInputLeftIcon"
          leftSection={
            <div className={styles.leftIconSection}>
              <img src={paymentMethodsConfig.IBAN.logo} className={styles.logo} />
              <span className={styles.subText}>{paymentMethodsConfig.IBAN.label}</span>
            </div>
          }
          rightSection={
            <FavoriteButton
              onChange={form.getInputProps('paymentMethods.iban.isFavorite').onChange}
              isFavorite={form.getInputProps('paymentMethods.iban.isFavorite').value}
            />
          }
          error={form.errors[CreatePaymentMethodDtoTypeEnum.Iban]}
          placeholder={t('contacts.ibanNumber', 'IBAN')}
          {...form.getInputProps('paymentMethods.iban.identifier')}
        />

        {!isCompany && (
          <>
            <TextInput
              variant="textInputLeftIcon"
              leftSection={
                <div className={styles.leftIconSection}>
                  <img src={paymentMethodsConfig.LYDIA.logo} className={styles.logo} />
                  <span className={styles.subText}>{paymentMethodsConfig.LYDIA.label}</span>
                </div>
              }
              rightSection={
                <FavoriteButton
                  onChange={form.getInputProps('paymentMethods.lydia.isFavorite').onChange}
                  isFavorite={form.getInputProps('paymentMethods.lydia.isFavorite').value}
                />
              }
              error={form.errors[CreatePaymentMethodDtoTypeEnum.Lydia]}
              placeholder={t('contacts.phoneNumber', 'Numéro de téléphone')}
              {...form.getInputProps('paymentMethods.lydia.identifier')}
            />

            <TextInput
              variant="textInputLeftIcon"
              leftSection={
                <div className={styles.leftIconSection}>
                  <img src={paymentMethodsConfig.PAYPAL.logo} className={styles.logo} />
                  <span className={styles.subText}>{paymentMethodsConfig.PAYPAL.label}</span>
                </div>
              }
              rightSection={
                <FavoriteButton
                  onChange={form.getInputProps('paymentMethods.paypal.isFavorite').onChange}
                  isFavorite={form.getInputProps('paymentMethods.paypal.isFavorite').value}
                />
              }
              error={form.errors[CreatePaymentMethodDtoTypeEnum.Paypal]}
              placeholder={t('contacts.email', 'email')}
              {...form.getInputProps('paymentMethods.paypal.identifier')}
            />

            <TextInput
              variant="textInputLeftIcon"
              leftSection={
                <div className={styles.leftIconSection}>
                  <img src={paymentMethodsConfig.WERO.logo} className={styles.logo} />
                  <span className={styles.subText}>{paymentMethodsConfig.WERO.label}</span>
                </div>
              }
              rightSection={
                <FavoriteButton
                  onChange={form.getInputProps('paymentMethods.wero.isFavorite').onChange}
                  isFavorite={form.getInputProps('paymentMethods.wero.isFavorite').value}
                />
              }
              error={form.errors[CreatePaymentMethodDtoTypeEnum.Wero]}
              placeholder={t('contacts.phoneNumber', 'Numéro de téléphone')}
              {...form.getInputProps('paymentMethods.wero.identifier')}
            />
          </>
        )}
      </div>
    </Fieldset>
  );
};

export default BankSectionForm;
